<!-- Layout 3: Image Left, Text Right -->
<div class="hero-container" *ngIf="data?.title || data?.description || data?.buttonText">
  <div class="hero-illustration" *ngIf="getImageSrc()">
    <img [src]="getImageSrc()" 
         [alt]="getImageAlt()"
         [ngStyle]="getImageStyles()"
         class="car-illustration">
  </div>
  <div class="hero-content">
    <h1 class="hero-title"
        *ngIf="data?.title"
        [style.color]="headingColor"
        [style.font-family]="headingFont"
        [ngStyle]="titleStyles">{{ data?.title }}</h1>
    <p class="hero-subtitle" 
       *ngIf="data?.subtitle"
       [style.color]="paragraphColor"
       [style.font-family]="bodyFont">
      {{ data?.subtitle }}
    </p>
    <p class="hero-description"
       *ngIf="data?.description"
       [style.color]="paragraphColor"
       [style.font-family]="bodyFont">
      {{ data?.description }}
    </p>
    <button class="hero-btn" 
            *ngIf="data?.buttonText"
            [style.background-color]="primaryColor"
            [style.color]="'#FFFFFF'"
            (click)="onButtonClick(data?.buttonLink, $event)">{{ data?.buttonText }}</button>
  </div>
</div>

